import React from 'react'

const TermsConditions = () => {
   return (
    <div className="max-w-5xl mx-auto py-16 px-6">
      <h1 className="text-3xl font-bold mb-6">
        T&C
      </h1>

      <p className="text-gray-700 text-lg leading-8">
        We have a 7-day return, refund, and replacement policy.
      </p>
    </div>
  );
};

export default TermsConditions